import { TStatesDataTableData } from "./StatesDataTableMeta";

const StatesFakeData: TStatesDataTableData[] = [
    {
        primaryKey: 1,
        entry: "Entry 2",
        stateParameter: "Screen Number",
        defaultValue: "",
        value: "010",
    },
    {
        primaryKey: 2,
        entry: "Entry 3",
        stateParameter: "Good Read Next State Number",
        defaultValue: "",
        value: "710",
    },
    {
        primaryKey: 3,
        entry: "Entry 4",
        stateParameter: "Error (Misread) Screen Number",
        defaultValue: "",
        value: "011",
    },
    {
        primaryKey: 4,
        entry: "Entry 5",
        stateParameter: "Read Condition 1",
        defaultValue: "",
        value: "003",
    },
    {
        primaryKey: 5,
        entry: "Entry 6",
        stateParameter: "Read Condition 2",
        defaultValue: "",
        value: "003",
    },
    {
        primaryKey: 6,
        entry: "Entry 7",
        stateParameter: "Read Condition 3",
        defaultValue: "",
        value: "002",
    },
    {
        primaryKey: 7,
        entry: "Entry 8",
        stateParameter: "Card Return Flag",
        defaultValue: "",
        value: "001",
    },
    {
        primaryKey: 8,
        entry: "Entry 9",
        stateParameter: "No FIT Match Next State Number",
        defaultValue: "",
        value: "058",
    },
]

export default StatesFakeData;